"use strict";

define('rs/models/role',['./abstract', 'rs/helper'], function (AbstractModel, helper) {
  var RoleModel = AbstractModel.extend({
    serverProperties: ["activityDate", "updateUserAuthId", "version", "id", "name", "description"],
    getDisplayName: function getDisplayName() {
      var name = helper.parseServerEnum(this.getName());
      if (name.slice(0, 5) == 'Role ') {
        name = name.slice(5);
      }
      return name;
    },
    requestUpdatePersonsWithRole: function requestUpdatePersonsWithRole(addPersonIds, removePersonIds) {
      return this.constructor.requestUpdatePersonsWithRole(this.getId(), addPersonIds, removePersonIds);
    }
  }, {
    rootURI: '/rs/api/',
    parsers: {
      '#get#role': function getRole(data) {
        return this.models(data);
      },
      '#get#role/person/:id': function getRole_person_Id(data) {
        return this.models(data);
      },
      '#post#role/person/:id': function postRole_person_Id(data) {
        return data;
      }
    },
    requestRoles: function requestRoles() {
      return this.get('role');
    },
    requestRolesByPerson: function requestRolesByPerson(id) {
      return this.get('role/person/' + (Number(id) || 0));
    },
    requestUpdatePersonsWithRole: function requestUpdatePersonsWithRole(roleId, addPersonIds, removePersonIds) {
      return this.post('role/' + (Number(roleId) || 0) + '/person', {
        insert: addPersonIds || undefined,
        remove: removePersonIds || undefined
      }, {
        jsonBody: true
      });
    }
  });
  return RoleModel;
});

